export enum InvoiceStatusEnum {
  "Active" = 1,
  "Inactive" = 2,
  "Paid" = 3,
  "Unpaid" = 4,
  "Overdue" = 5,
  "Cancelled" = 6,
  "Refunded" = 7,
  "Partially Paid" = 8,
  "Partially Refunded" = 9,
  "Partially Overdue" = 10,
  "Partially Cancelled" = 11
}

export enum InvoiceEnum {
  // Default values
  DEFAULT_STATUS = InvoiceStatusEnum.Active,
}
